import React, { useState } from "react";
import PromoCard from "./PromoCard";
import PromoDialog from "./PromoDialog";
import { getActivePromotions } from "../../data/promotions";

/**
 * Filas que ocupa la tarjeta grande según cuántas la acompañan. Son strings
 * literales porque Tailwind necesita ver la clase completa en el código.
 * De la quinta en adelante, el sobrante sigue en la fila de abajo.
 */
const FEATURED_SPAN = {
	2: "lg:row-span-2",
	3: "lg:row-span-3",
	4: "lg:row-span-4"
};

/**
 * Bloque de promociones vigentes.
 *
 * variant="client": es lo primero que ve el cliente logueado, así que el
 * título va como h1 sobre el fondo papel.
 * variant="public": misma grilla, como sección secundaria de la home pública.
 *
 * La grilla se adapta a la cantidad de promociones activas: la de menor
 * prioridad ocupa la tarjeta grande, alta como la columna de las demás.
 */
const Promotions = ({ variant = "public" }) => {

	const [openPromo, setOpenPromo] = useState(null);
	const promotions = getActivePromotions();

	if (promotions.length === 0) return null;

	const isClient = variant === "client";
	const [featured, ...rest] = promotions;
	const Heading = isClient ? "h1" : "h2";

	return (
		<section
			id="promociones"
			className={ `anchor-target ${isClient ? "bg-paper py-9 lg:pb-[59px] lg:pt-[49px]" : "bg-white py-16 lg:py-24"}` }
		>
			<div className="shell">
				<div className="mb-7 grid items-end gap-5 lg:mb-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-12 xl:gap-20">
					<div>
						<p className="eyebrow">Actualidad comercial</p>
						<Heading className={ `mt-3 ${isClient ? "display-1" : "display-2"}` }>
							Promociones vigentes.
						</Heading>
					</div>

					<p className="m-0 max-w-[460px] text-[15px] leading-relaxed text-muted lg:pb-1.5 lg:text-base">
						Beneficios disponibles en productos seleccionados, con sus mecánicas y condiciones actualizadas.
					</p>
				</div>

				<div
					className={ rest.length > 0
						? "grid gap-4 lg:auto-rows-[277px] lg:grid-cols-[minmax(0,2fr)_minmax(300px,.94fr)]"
						: "grid gap-4" }
				>
					<PromoCard
						promo={ featured }
						featured
						spanClassName={ FEATURED_SPAN[Math.min(rest.length, 4)] || "" }
						onOpenConditions={ setOpenPromo }
					/>
					{
						rest.map((promo, index) => (
							<PromoCard key={ index } promo={ promo } onOpenConditions={ setOpenPromo } />
						))
					}
				</div>
			</div>

			{
				openPromo &&
					<PromoDialog promo={ openPromo } onClose={ () => setOpenPromo(null) } />
			}
		</section>
	);
};

export default Promotions;
